import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const BlockImgStyled = styled.img`
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radii[300]};
`;

export const AttachmentGroupStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  & > :last-child {
    border-bottom: solid 1px ${({ theme }) => theme.colors.grey[300]};
  }
`;

export const DeleteAttachmentStyled = styled.div`
  position: absolute;
  ${({ theme }) => css`
    margin-top: ${theme.spacings[400]};
    right: ${theme.spacings[600]};
    z-index: 1;
  `}
`;
